import React from 'react';
import styled, { css } from 'styled-components';

import { colorScheme } from '../../theme';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode | React.ReactNode[];
  variant?: string;
  isActive?: boolean;
}

const basicStyle = {
  outline: 'none',
  zIndex: '9',
  padding: '0',
  borderRadius: '4px',
  height: '80px',
  width: '80px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: '150ms linear all',
  background: `${colorScheme.card.background}`,
  border: `0.6px solid ${colorScheme.card.border}`,
  color: `${colorScheme.text.base}`,
} as const;

const variantStyles = (variant?: string) =>
  variant &&
  {
    geolocate: css`
      width: 56px;
      height: 56px;
      right: 24px;
      bottom: 24px;
      background: ${colorScheme.card.background};
      position: absolute;
      border: 0.6px solid ${colorScheme.card.border};
    `,
  }[variant];

export const MapButton = styled.button<Props>`
  ${basicStyle}
  ${({ isActive }) =>
    isActive &&
    css`
      box-shadow: ${colorScheme.card.border} 0px 1px 4px;
    `}

  ${({ variant }) => variantStyles(variant)}
`;
